<template>
  <div class="commerce-agent-order main">
    <div v-if="t" :class="{ 'bg-grey': !t.is_ongoing, 'bg-pink': isFailedOrder }" :key="key">
      <OrderDetailsCommerceAgentDelivery v-if="showDelivery && t.delivery" :t="t.delivery" :notes="deliveryNotes"
        @close="showDelivery = false" />

      <fade-transition v-if="false">
        <OrderDetailsCommerceAgentFeesBangkok v-if="showFees" :fulfilment="t.data.type" :fees="t.data.order"
          :lalamoveFee="lalamoveFee" :billing="parseFloat(t.data.billing || 0)" :currency="currency"
          @close="showFees = false" />
      </fade-transition>

      <fade-transition v-if="true">
        <OrderDetailsCommerceAgentFees v-if="showFees" :fulfilment="t.data.type" :fees="t.data.order"
          :lalamoveFee="lalamoveFee" :billing="parseFloat(t.data.billing || 0)" :currency="currency"
          @close="showFees = false" />
      </fade-transition>

      <div class="wrapper no-scrollbar" :key="z">
        <!-- <div class="no-scrollbar" :key="z"> -->
        <section class="has-text-left no-scrollbar">
          <div style="margin-bottom: 10px">
            <span class="tag is-pulled-right has-text-weight-semibold" :class="stateClass" style="margin-top: 4px"
              @click="gotoCustomerOrder">
              {{ prettyState }}
            </span>
            <h1 class="is-size-5 has-text-weight-medium" @click="z += 1">
              <span @click="preClose">
                <i class="fa fa-chevron-left" style="padding: 6px" />
                {{ $t("commerce.order-details") }}
                <i v-if="updating" class="fa fa-spinner fa-spin fa-sm" />
              </span>
            </h1>
          </div>

          <div v-if="showOrderConfirmationReminder" style="height: 50px" />

          <div v-if="isTest" class="notification is-danger" style="padding: 10px" @click="showTest = false">
            {{ $t("ecommerce.this-is-a-test-order") }}
          </div>

          <div v-if="t.is_deleted" class="notification is-danger" style="padding: 10px">
            {{ $t("ecommerce.this-order-is-deleted") }}
          </div>

          <div v-if="!t.is_ongoing" class="notification is-dark" style="padding: 10px" @click="init">
            {{ $t("ecommerce.this-order-is-finished") }}
            <span class="is-pulled-right">
              {{ timeAgo(t.updated_at) }}
            </span>
          </div>

          <div v-if="!isDelivery" class="notification is-white fulfilment">
            <i class="fa" :class="fulfilmentIcon" />
            {{ fulfilmentType }} Order
            <span class="is-pulled-right has-text-danger">{{
              $t("commerce.not-a-delivery")
            }}</span>
          </div>

          <div v-if="t.data.order.fulfilment_time" class="notification is-black has-text-danger"
            style="padding: 10px; font-size: 1.2em" @click="showAdvanceOrderInfo = !showAdvanceOrderInfo">
            <i class="fa fa-info-circle has-text-white is-pulled-right" />
            <p class="pulse">{{ $t("ecommerce.advance-order") }}</p>
            <p style="font-size: 2em">
              <i class="far fa-clock" style="margin: 6px" />
              {{ $t("ecommerce.pickup-order-at") }} {{ advanceOrderPickupTime }}
            </p>
            <p v-if="isDelivery">
              <i class="fa fa-motorcycle" />&nbsp;{{
                $t("ecommerce.request-driver-at-x", { x: requestDriverTime })
              }}
            </p>
            <p v-else>
              <i class="far fa-user" />&nbsp;{{ $t("commerce.not-a-delivery") }}
            </p>
            <p v-if="showAdvanceOrderInfo" class="has-text-warning" style="font-size: 0.8em">
              This is an ADVANCE ORDER.<br />Please prepare the order by the
              time specified.<br />Remember to request the driver 20 minutes
              before the pickup time.
            </p>
          </div>

          <div v-if="isNew && showPrepTimeSelector" class="prep-time-selector">
            <p class="subtitle has-text-left" style="font-size: 1em; font-weight: 500">
              <i>{{ $t("ecommerce.prep-time-?") }}</i>
              <span v-if="eta" class="is-pulled-right" @click="eta = null">
                <span class="link">{{ eta }} {{ $t("minutes") }}</span>
              </span>
            </p>
            <p v-if="!eta" class="buttons" style="padding-top: 8px">
              <a v-for="i in etas" :key="i" class="button eta-btns" @click="eta = i">
                {{ i }}
              </a>
            </p>
          </div>

          <p v-if="superuser" class="notification is-light single-line shop-name" style="padding: 10px"
            @click="goto('shop/' + t.data.business.id)">
            <span>{{ t.data.business.name }}</span>
            <i class="fa fa-store-alt fa-sm" style="position: absolute; right: 10px; margin-top: 4px" />
          </p>

          <div class="transaction">
            <div v-if="isAgentOrder" class="tuk-express-wrapper" @click="shareToCustomer">
              <span>
                <svgicon icon="tuk-word" width="30" height="30" color="navy" :fill="true" style="margin-top: -6px">
                </svgicon>
                <i class="tuk-express">EXPRESS</i>
              </span>
              <span class="is-pulled-right link pulse" style="font-size: 0.9em">
                Share to customer
                <i class="fa fa-share-alt has-text-link pulse" />
              </span>
              <p>
                Share order link to customer and tell them the total amount to
                pay to the driver is
                <span style="font-weight: 500; color: black">{{ currency }}{{ customerTotalAgentMode }}</span>
              </p>
            </div>
            <div class="is-flex no-print">
              <div class="ticket" @click="incrementOrderNumber">
                <p class="is-size-3 has-text-weight-semibold" style="line-height: 1em">
                  {{ ref }}
                </p>
                <p>
                  <i class="fa is-size-4" :class="fulfilmentIcon" />
                </p>
                <p style="margin-top: -6px">{{ fulfilmentType }}</p>
              </div>
              <div class="customer-wrapper">
                <span class="tag is-white icon is-medium has-text-success phone-btn"
                  @click="callPhoneNumber(t.customer.phone_number)">
                  <i class="fa fa-phone" />
                </span>
                <p class="name" @click="showCustomerPhone = !showCustomerPhone">
                  <i class="fa fa-user fa-sm pad" />
                  <span class="link">{{ customerName }}</span>
                </p>
                <p v-if="showCustomerPhone">
                  <i class="fa fa-phone fa-sm pad" />
                  <span>{{ t.customer.phone_number }}</span>
                  <i v-if="superuser" class="fa fa-external-link-alt fa-sm has-text-link" style="padding-left: 6px"
                    @click="goto(`user_info/${t.customer.id}`)" />
                  <span v-if="isDelivery" class="link is-pulled-right" @click="openDeliveryAddress">
                    <i class="fa fa-map-marker-alt has-text-link" />
                    Address
                  </span>
                </p>
                <p style="margin-top: 6px" @click="forceUpdate">
                  <i class="far fa-clock fa-sm pad" />{{
                    $t("ecommerce.ordered")
                  }}
                  <span class="has-text-weight-medium">
                    {{ timeAgo(t.created_at) }}
                  </span>
                  <span v-if="superuser && t.is_ongoing && t.data.event_confirmed" class="has-text-link confirmed-ago">
                    Confirmed<br />{{ timeAgo(t.data.event_confirmed) }}
                  </span>
                </p>
                <p>
                  <i class="fa fa-coins fa-sm pad" />
                  <span class="link has-text-weight-medium" @click="showPaymentInfo">{{ currency }}{{
                    orderValue
                  }}</span>
                  <!-- <span class="has-text-link is-uppercase payment">{{
                    translatePayment(t.data.order.payment_method)
                  }}</span> -->
                  <span v-if="superuser && changeFor" class="tag">From {{ currency }}{{ changeFor }}</span>

                  <span v-if="isPaid">
                    <i class="fa fa-check-circle has-text-success" />
                    PAID
                  </span>
                </p>
                <p v-if="isSOL">
                  <i class="fa fa-info-circle pad" />
                  <span class="total-sol">{{ convertEURtoSOLPretty(orderValue) }} SOL</span>
                </p>
                <p v-if="superuser && promoCode">
                  <i class="fa fa-gift pad" />
                  <span class="has-text-danger is-uppercase has-text-weight-bold">{{ promoCode }}</span>
                </p>
                <div v-if="orderCount != null" class="order-cnt" @click="orderCountInfo">
                  <span v-if="orderCount">
                    {{ orderCount }} {{ $t("profile.orders") }}
                  </span>
                  <span v-else>{{ $t("ecommerce.new-customer") }}!</span>
                </div>
              </div>
            </div>
          </div>

          <div v-if="swipe && !isSubmitted" class="columns is-mobile is-vcentered has-text-centered"
            style="padding: 0; margin-top: 10px">
            <div class="column ios-btn">
              <i v-if="isIOS" :class="iosClassA" @click="iosSlide('a')" />
            </div>
            <div class="column" style="padding: 0 0">
              <drag-verify :key="z" :width="w" :height="40" :textSize="'14'" :handlerIcon="'fa fa-angle-right fa-lg'"
                :successIcon="'fa fa-check fa-sm'" :text="swipe.text" :circle="true" :successText="swipe.successText"
                :background="swipe.background" @passcallback="done" class="has-text-white has-text-weight-semibold"
                :class="{ pulse: isPulse }"></drag-verify>
            </div>
            <div class="column ios-btn" :class="{ pulse: iosTrigger.a }">
              <i v-if="isIOS" :class="iosClassB" @click="iosSlide('b')" />
            </div>
          </div>

          <div v-if="isDelivery" class="transaction driver">
            <div v-if="!t.delivery" class="no-driver has-text-link" @click="openDeliveryDetails">
              <span v-if="loadingDelivery">
                <b-skeleton v-if="state === 'initiated'" height="24px" />
                <b-skeleton v-else height="60px" />
              </span>
              <span v-else-if="isDelayedDelivery">
                <span v-if="state === 'initiated' && !deliveryDelayDuration" @click="infoCallCustomerDeliveryTime">
                  <i class="far fa-clock" />
                  &nbsp;{{
                    $t("ecommerce.call-customer-to-arrange-delivery-time")
                  }}
                  <i class="fa fa-info-circle info" />
                </span>
                <!-- <span v-else class="has-text-danger" @click="infoDelayedRequestDriver"> -->
                <span v-else-if="shopAllowedToRequestDriver" class="has-text-danger" @click="done">
                  <i class="fa fa-shipping-fast" />
                  &nbsp;{{ $t("ecommerce.request-driver-when-order-is-ready") }}
                  <span v-if="state === 'confirmed'">
                    <br />
                    <span class="button is-danger is-medium has-text-weight-bold is-fullwidth" style="margin-top: 6px">{{
                      $t("ecommerce.order-ready-in-10-mins-?")
                    }}<i class="fa fa-chevron-right" style="margin-left: 8px" /></span>
                  </span>
                </span>
                <span v-else class="has-text-danger">
                  <i class="fa fa-motorcycle" />&nbsp;{{
                    $t("ecommerce.request-driver-at-x", { x: requestDriverTime })
                  }}
                </span>
              </span>
              <span v-else-if="isThirdPartyDelivery">
                <i class="fa fa-shipping-fast" />
                &nbsp;Third-Party Delivery
              </span>
              <span v-else-if="t.is_ongoing" @click="infoConfirmRequestDriver">
                <i class="fa fa-shipping-fast" />
                &nbsp;{{ $t("delivery.confirm-to-request-driver") }}
                <i class="fa fa-info-circle info" />
              </span>
              <span v-else>
                <i class="fa fa-check-circle" />
                &nbsp;{{ $t("Delivery completed") }}
              </span>
            </div>
            <div v-else-if="isThirdPartyDelivery" class="no-driver has-text-black is-pointer"
              style="border: inital; box-shadow: 0 0 1px var(--link)" @click="enterThirdPartyTrackingLink">
              <i class="far fa-edit" />&nbsp; Enter Third-Party Tracking Link
            </div>
            <div v-else-if="isRequestingDriver" class="no-driver has-text-link" @click="infoRequestingDriver">
              <i class="fa fa-spinner fa-spin" />
              &nbsp;{{ $t("delivery.requesting-delivery-driver") }}
              <i class="fa fa-info-circle info" />
            </div>
            <div v-else-if="isRequestAgain" class="no-driver has-text-right">
              <div v-if="state !== 'timed_out'">
                <span style="font-size: 1.2em; float: left; padding: 6px">
                  <i class="fa fa-exclamation-triangle has-text-danger" />
                  <span style="font-weight: 500; margin-left: 4px">
                    {{ $t("delivery.no-driver") }}
                  </span>
                </span>
                <span class="tag is-success is-large has-text-weight-medium" @click="retryDelivery">
                  {{ $t("try-again") }}&nbsp;
                  <i class="fa fa-chevron-right" />
                </span>
              </div>
              <div v-else>
                <span class="tag is-danger is-large">
                  <i class="fa fa-exclamation-triangle" />
                  &nbsp;{{ prettyState }}
                </span>
              </div>
            </div>
            <div v-else-if="t.delivery.driver" class="is-flex">
              <div
                style="
                                                                                                                                                                                                                                            flex-shrink: 1;
                                                                                                                                                                                                                                            text-align: center;
                                                                                                                                                                                                                                            margin-right: 4px;
                                                                                                                                                                                                                                            padding-bottom: 0;
                                                                                                                                                                                                                                            margin-bottom: 0;
                                                                                                                                                                                                                                          ">
                <img :src="driverProfilePic" class="driver-img" />
                <div class="plate-number">
                  {{ driverVehicleNumber }}
                </div>
              </div>
              <div style="flex: 1; padding: 4px">
                <span class="tag is-white is-medium has-text-success icon phone-btn"
                  @click="callPhoneNumber(t.delivery.driver.phone_number)">
                  <i class="fa fa-phone" />
                </span>
                <p class="name" @click="showDriverPhone = !showDriverPhone">
                  <i class="fa fa-motorcycle fa-sm pad" />
                  <span class="link">{{ driverName }}</span>
                </p>
                <p v-if="showDriverPhone">
                  <i class="fa fa-phone fa-sm pad" />
                  <span>{{ t.delivery.driver.phone_number }}</span>
                  <i v-if="superuser" class="fa fa-external-link-alt fa-sm has-text-link" style="padding-left: 6px"
                    @click="goto(`user_info/${t.delivery.driver.id}`)" />
                </p>
                <p v-if="t.delivery.driver.role" class="is-flex" style="margin-top: 8px">
                  <span style="line-height: 1.8em">
                    <i v-if="t.delivery.state === 'alighted'" class="fa fa-check fa-sm pad" />
                    <i v-else class="fa fa-spinner fa-spin fa-sm pad" />
                  </span>
                  <span v-if="isDelivery" class="tag is-dark has-text-weight-medium"
                    style="font-size: 0.9em; margin-right: 3px">
                    {{ deliveryState }}
                  </span>
                  <span v-if="showDeliveryDetails" class="map-btn" @click="showDelivery = true">
                    View on Map
                    <span class="is-pulled-right">
                      <i class="fa fa-chevron-right" />
                    </span>
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div v-if="isTakeaway && state.includes('confirmed', 'ready')" class="transaction driver">
            <div class="no-driver has-text-link">
              <span v-if="state === 'confirmed'">
                <i class="fa fa-walking" />
                &nbsp;Remember to tell the customer when it's ready
              </span>
              <span v-else-if="state === 'ready'" class="has-text-danger">
                <i class="far fa-clock" />
                &nbsp;Call customer if they don't collect order within 10 mins
              </span>
            </div>
          </div>

          <div v-if="orderNotes" class="order-notes" @click="copy(orderNotes)">
            <i class="far fa-comment-alt has-text-grey" style="margin: 4px" @click="openNotesReminder" />
            <span class="option-menu">{{ $t("ecommerce.notes") }}</span>
            <span class="has-text-danger has-text-weight-medium" style="margin-left: 4px">{{ orderNotes }} <i
                class="far fa-copy fa-sm has-text-black" /></span>
          </div>

          <div id="to-print">
            <table class="table is-fullwidth" :key="y">
              <thead>
                <tr v-if="editingOutOfStock">
                  <th colspan="3" class="has-text-danger has-text-right"
                    style="padding: 16px 10px; background-color: black">
                    <span class="cancel-edit link" @click="toggleEditingOutOfStock">
                      <i class="fa fa-chevron-left" />&nbsp;{{ $t("done") }}
                    </span>
                    <span @click="removeItemInfo">
                      <i class="fa fa-minus" />
                      {{ $t("ecommerce.remove-item") }}&nbsp;<i class="fa fa-arrow-down fa-lg" />
                    </span>
                  </th>
                </tr>
                <tr v-else>
                  <th colspan="2" style="padding-right: 0">
                    <span style="padding: 7px; margin-right: 9px" @click="print">
                      <!-- <i v-if="printing" class="fa fa-spinner fa-spin" /> -->
                      <i class="fa fa-print link" style="line-height: 1.3em" />
                    </span>

                    <span class="buttons is-uppercase" style="display: inline-block">
                      <span v-for="l in languages" :key="l"
                        class="button is-small is-rounded has-text-weight-medium is-uppercase"
                        :class="{ 'is-white': lang !== l }" style="padding: 0 4px; margin: 0" @click="lang = l">{{
                          l
                        }}</span>
                    </span>
                  </th>
                  <th class="right is-narrow">
                    <i class="fa fa-camera-retro link" style="line-height: 1.2em" @click="toggleMenuInfo" />
                  </th>
                </tr>
              </thead>
              <tbody v-for="(o, i) in basketItems" :key="i" class="items" :class="{
                'item-complete': itemComplete(o.item),
                'items-shadow': editingOutOfStock,
              }" @click="toggleItemComplete(o.item)">
                <tr :class="{
                  'no-bottom-border': o.item.options,
                  'special-item-positive':
                    isSpecialItem(o) && discountedTotalPrice(o.item) >= 0,
                  'special-item-negative':
                    isSpecialItem(o) && discountedTotalPrice(o.item) < 0,
                }">
                  <td style="padding-right: 0">
                    <span style="color: grey; font-weight: 450" @click="triggerEditItem(o)">
                      <span :class="{
                        'has-text-weight-bold pulse': o.quantity > 1,
                        'has-text-danger': o.out_of_stock,
                      }" style="margin-right: 3px">{{ actualQuantity(o) }}</span>x </span><span v-if="o.item.free_gift"
                      class="has-text-danger" style="font-size: 0.8em; font-weight: 500; opacity: 0.8">
                      <i class="fa fa-gift" />&nbsp;Free Gift </span><span v-if="isSpecialItem(o)">*</span>{{
                        itemName(o.item)
                      }}<span v-if="isSpecialItem(o)">*</span>
                    <i v-show="o.item.discount" class="fa fa-tag has-text-danger"
                      style="opacity: 0.7; font-size: 0.7em; margin-left: 2px" />
                    <i v-if="o.item.prep_time > 20" class="fa fa-stopwatch fa-sm"
                      style="opacity: 0.7; margin-left: 2px" />
                    <p v-if="o.out_of_stock" class="out-of-stock">
                      {{ $t("commerce.out-of-stock") }}: {{ o.out_of_stock }}
                      <span style="opacity:0.8">of {{ o.quantity }}</span>
                    </p>
                  </td>
                  <td class="is-narrow nowrap" style="padding-right: 0">
                    <span :class="{
                      'has-text-weight-bold pulse': o.quantity > 1,
                    }">{{ actualQuantity(o) }}</span>
                    x
                    {{ currency }}{{ discountedTotalPrice(o.item) }}
                  </td>
                  <td class="right is-narrow">
                    <span v-if="editingOutOfStock" class="trash-btn" @click="preRemoveItem(o)"><i v-if="!o.out_of_stock"
                        class="fa fa-trash-alt has-text-danger" /><i v-else class="fa fa-undo has-text-link" /></span>
                    <span v-else>{{
                      currency
                    }}{{ actualQuantity(o) * discountedTotalPrice(o.item) }}</span>
                  </td>
                </tr>
                <tr v-if="o.item.by_weight" :class="{ 'no-bottom-border': o.item.options }">
                  <td colspan="3" class="td-options">
                    <p v-if="o.item.by_weight" class="by-weight" @click="editWeight(o)">
                      <i class="fa fa-weight fa-sm" />&nbsp;
                      <span v-if="!o.weighed">~</span>{{ o.item.actual_weight }}
                      grams per piece
                      <!-- *to be weighed* -->
                      <span class="is-pulled-right tag is-rounded" :class="{ 'is-success': !o.weighed }"
                        style="font-weight: 500; box-shadow: 0 0 2px black">
                        <span v-if="o.weighed">Edit Weight</span>
                        <span v-else>Enter Weight</span>
                      </span>
                    </p>
                  </td>
                </tr>
                <tr v-if="hasOptions(o) || o.item.comment">
                  <td colspan="3" class="td-options">
                    <div class="options">
                      <p v-for="o in o.item.options" :key="o.item">
                        <span class="option-menu">
                          &nbsp;•&nbsp;{{ optionMenuName(o) }}
                        </span>
                        <span v-if="o.option.quantity > 1">{{ o.option.quantity }} x</span>
                        {{ optionItemName(o) }}
                      </p>
                      <p v-if="o.item.comment" class="pulse" @click="copy(o.item.comment)">
                        <i class="far fa-comment-alt option-menu" style="margin-left: 2px" />
                        <span class="option-menu" style="margin-left: 2px">{{ $t("ecommerce.special-request") }}</span>
                        <i class="has-text-danger has-text-weight-bold" style="margin-left: 0px">
                          {{ o.item.comment }}
                          <i class="far fa-copy fa-sm has-text-black" />
                        </i>
                      </p>
                    </div>
                  </td>
                </tr>
                <tr v-if="showDescriptions" style="background-color: white">
                  <td colspan="3">
                    <div class="more-info is-flex">
                      <img class="item-img" :class="{ 'contain-img': o.item.contain_image }"
                        v-webp="o.item.pic || placeholderPic" />
                      <div v-if="o.item.sku" class="sku">{{ o.item.sku }}</div>
                      <div>
                        <span v-if="o.item.category" class="category-name">{{
                          o.item.category
                        }}</span>
                        <span v-if="itemDescription(o.item)">{{
                          itemDescription(o.item)
                        }}</span>
                        <p v-if="o.item.notes" class="staff-notes">
                          <i class="fa fa-mitten" />&nbsp;{{ o.item.notes }}
                        </p>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="!editingOutOfStock">
                <tr style="opacity: 0.5">
                  <td></td>
                  <th class="is-narrow nowrap" style="padding-right: 0">
                    {{ $t("ecommerce.subtotal") }}
                  </th>
                  <th class="right">
                    {{ currency }}{{ t.data.order.order_value }}
                  </th>
                </tr>
                <tr v-if="fulfilmentDiscount" class="has-text-info">
                  <td class="wide">{{ fulfilmentText }} Discount</td>
                  <td />
                  <td class="right nowrap">
                    −{{ currency }}{{ fulfilmentDiscount }}
                  </td>
                </tr>
                <tr v-if="vat">
                  <td>{{ $t("VAT") }}</td>
                  <td></td>
                  <td class="right nowrap">{{ currency }}{{ vat }}</td>
                </tr>
                <tr v-if="lalamoveFee" class="has-text-grey" @click="showFees = true">
                  <td>
                    {{ $t("menu.fees") }}
                    <i style="font-size: 0.85em; color: #bbb">
                      <i class="fa fa-info-circle" />
                    </i>
                  </td>
                  <td></td>
                  <td class="right nowrap">
                    <span v-if="netFeesAndDiscounts > 0">+</span>
                    <span v-else>−</span>
                    {{ currency }}{{ Math.abs(netFeesAndDiscounts) }}
                  </td>
                </tr>
                <tr v-else class="has-text-grey" @click="editServiceFee">
                  <td>{{ $t("ecommerce.service-fee") }}</td>
                  <td></td>
                  <td class="right nowrap">− {{ currency }}{{ serviceFee }}</td>
                </tr>
              </tbody>
              <tfoot v-if="!editingOutOfStock">
                <tr class="big-table-row">
                  <th>
                    <span :class="{
                      'has-text-weight-bold pulse':
                        basketItemCount > basketItems.length,
                    }">{{ basketItemCount }}</span>
                    {{ $t("menu.items") }}
                  </th>
                  <th style="white-space: nowrap; padding-right: 0">
                    {{ $t("ecommerce.total") }}
                  </th>
                  <th class="right">{{ currency }}{{ orderValue }}</th>
                </tr>
                <tr v-if="orderValue < 0" class="big-table-row" style="background-color: orange">
                  <th colspan="2">You (Shop) Pay Driver</th>
                  <th class="right">
                    {{ currency }}{{ Math.abs(orderValue) }}
                  </th>
                </tr>
                <tr v-if="receiptPrice" style="background-color: #aff; opacity: 0.66"
                  @click="infoToast('Driver reported total', 'top')">
                  <th colspan="2">
                    {{ $t("Receipt Price") }}
                  </th>
                  <th class="right">{{ currency }}{{ receiptPrice }}</th>
                </tr>
              </tfoot>
            </table>

            <div v-if="editingOutOfStock">
              <span class="button is-fullwidth is-danger is-medium" @click="toggleEditingOutOfStock"><i
                  class="fa fa-spinner fa-spin" />&nbsp;Finish Editing</span>
            </div>
          </div>
          <div style="margin-top: 8px">
            <span v-if="showCancel">
              <span class="button is-danger is-outlined" @click="cancelOrder">
                <!-- {{$t("ecommerce.cancel-order")}}  -->
                <i class="fa fa-exclamation-triangle fa-sm" />&nbsp;{{
                  $t("cancel")
                }}</span>&nbsp;
              <span class="button is-link is-outlined" @click="triggerShowEditPanel">
                <i class="fa fa-edit fa-sm" />&nbsp;{{ $t("edit") }}</span>&nbsp;
              <span v-if="superuser" class="button is-dark is-outlined" style="padding: 0 14px"
                @click="showAdvancedOptions = true">
                <i class="fa fa-ellipsis-v" />
              </span>
            </span>
            <span v-else-if="state === 'timed_out'" class="button is-rounded is-warning is-small"
              @click="restartOrder">Restart</span>
            <span class="order-id" @click="copyOrderID">
              {{ $t("ecommerce.order-id") }}<br />{{ orderID }}
            </span>
          </div>
          <div v-if="deliveryNotes" class="delivery-notes" style="margin-top: 8px" @click="copy(deliveryNotes)">
            <span class="has-text-grey" style="margin-right: 6px">
              <i class="fa fa-shipping-fast" />
              <span class="option-menu" style="margin-left: 4px">{{ $t("address.delivery") }}</span>
            </span>
            <span class="has-text-weight-medium">{{ deliveryNotes }}
              <i class="far fa-copy fa-sm has-text-black" /></span>
          </div>

          <div class="button is-fullwidth" style="margin: 10px 0" @click="contactMerchantSupport()">
            <i>{{ $t("commerce-order.need-help-with-order-?") }}</i>
          </div>

          <div v-if="showEditOrder" class="edit-order-wrapper">
            <p class="subtitle" style="padding: 6px; padding-bottom: 12px" @click="closeEditOrder">
              <span style="font-weight: 500; color: white">
                <span v-if="isEditDiscount">Add Discount</span>
                <span v-else>{{ $t("ecommerce.add-item") }}</span>
              </span>
              <button class="delete is-large is-pulled-right" style="margin: -6px" />
            </p>
            <div class="field">
              <textarea class="textarea" :placeholder="isEditDiscount
                ? 'Discount Description or Comments'
                : $t('ecommerce.item-name-description-comments')
                " rows="2" v-model="manualItemName"></textarea>
            </div>

            <div class="field is-grouped">
              <div class="control has-icons-left">
                <span class="icon is-small is-left is-dark">
                  {{ currency }}
                </span>
                <input class="input" style="width: 150px" type="number" v-model="manualItemPrice"
                  :placeholder="isEditDiscount ? 'Discount' : $t('price')" />
              </div>

              <div v-if="!isEditDiscount" class="control has-icons-left">
                <span class="icon is-small is-left is-dark">
                  <i class="fa fa-plus-circle" />
                </span>
                <input class="input" style="width: 100px" type="number" v-model="manualItemQuantity"
                  :placeholder="$t('menu.qty')" />
              </div>
            </div>

            <div class="field" style="margin-top: 20px">
              <a class="button is-fullwidth is-link is-medium" @click="addManualItem">
                {{ $t("submit") }}&nbsp;<i class="fa fa-chevron-right" />
              </a>
            </div>
            <p>
              <i> {{ $t("ecommerce.please-call-customer") }} </i>
            </p>
            <p style="margin-top: 10px">
              <i> {{ $t("ecommerce.customer-and-driver") }} </i>
            </p>
            <!-- <p style="margin-top: 10px">
            <i> {{ $t("ecommerce.to-remove-item") }} </i>
          </p>
          <p style="margin-top: 10px">
            <i> {{ $t("ecommerce.pizza-edit-example") }} </i>
          </p> -->
          </div>
        </section>
      </div>

      <OrderConfirmationReminderPanel v-if="showOrderConfirmationReminder" @accept="done"
        @close="closeOrderConfirmationReminder" />

      <CommerceAgentOrderOptionsPanel v-if="showAdvancedOptions" :t="t" @close="showAdvancedOptions = false"
        @update="init" @messageAgents="messageAgents" />

      <CommerceAgentOrderEditPanel v-if="showEditPanel" @add="startEditOrderAdd" @remove="editingOutOfStock = true"
        @discount="startEditOrderDiscount" @close="showEditPanel = false" />

      <CommerceAgentOrderWeightPanel v-if="showEnterWeight" :o="weightItem" :currency="currency"
        @editWeight="editItemWeight" @close="showEnterWeight = false" />

      <CommerceAgentOrderSuperEditPanel v-if="showEditItem" :o="editingItem" :currency="currency" @editItem="editItem"
        @close="showEditItem = false" />
    </div>

    <div v-else-if="!role" class="wrapper" style="padding: 0">
      <div style="padding: 12px">
        <span class="tag is-pulled-right" style="margin-top: 4px" @click="goHome">
          <i class="fa fa-home" />
        </span>
        <h1 class="is-size-5 has-text-weight-medium">
          <span @click="close">
            <i class="fa fa-lock" style="padding: 6px" />
            Please login to view this page
          </span>
        </h1>
      </div>
    </div>

    <div v-else class="wrapper" :class="$store.state.theme" style="padding: 0">
      <div style="padding: 12px">
        <h1 class="is-size-5 has-text-weight-medium">
          <span @click="close">
            <i class="fa fa-chevron-left" style="padding: 6px" />
            {{ $t("ecommerce.loading-order-details") }}
          </span>
        </h1>
      </div>
      <div style="padding: 10px; opacity: 0.5">
        <progress class="progress is-large is-white" max="1" />

        <!-- <div style="height: 20px" /> -->
        <article class="media">
          <figure class="media-left">
            <p class="image">
              <b-skeleton square width="80px" height="80px"></b-skeleton>
            </p>
          </figure>
          <div class="media-content">
            <div class="content">
              <p>
                <!-- <b-skeleton active></b-skeleton> -->
                <b-skeleton height="80px"></b-skeleton>
              </p>
            </div>
          </div>
        </article>

        <div style="height: 10px" />
        <b-skeleton height="40px"></b-skeleton>

        <div style="height: 20px" />
        <b-skeleton height="30px"></b-skeleton>

        <div style="height: 20px" />
        <b-skeleton height="200px"></b-skeleton>

        <div style="height: 20px" />
        <b-skeleton height="40px" width="200px"></b-skeleton>
      </div>
    </div>
  </div>
</template>


<script>
import OrderDetailsCommerceAgentDelivery from "@/components/OrderDetailsCommerceAgentDelivery";
import OrderDetailsCommerceAgentFees from "@/components/OrderDetailsCommerceAgentFees";
import OrderDetailsCommerceAgentFeesBangkok from "@/components/OrderDetailsCommerceAgentFeesBangkok";
import OrderConfirmationReminderPanel from "@/components/OrderConfirmationReminderPanel";
import CommerceAgentOrderOptionsPanel from "@/components/CommerceAgentOrderOptionsPanel";
import CommerceAgentOrderEditPanel from "@/components/CommerceAgentOrderEditPanel";
import CommerceAgentOrderWeightPanel from "@/components/CommerceAgentOrderWeightPanel";
import CommerceAgentOrderSuperEditPanel from "@/components/CommerceAgentOrderSuperEditPanel";

import dragVerify from "vue-drag-verify";
import { sounds } from "../functions.js";
import EventBus from "../eventBus";

const shortid = require("shortid");

export default {
  name: "CommerceAgentOrder",
  components: {
    dragVerify,
    OrderDetailsCommerceAgentDelivery,
    OrderDetailsCommerceAgentFees,
    OrderDetailsCommerceAgentFeesBangkok,
    OrderConfirmationReminderPanel,
    CommerceAgentOrderOptionsPanel,
    CommerceAgentOrderEditPanel,
    CommerceAgentOrderWeightPanel,
    CommerceAgentOrderSuperEditPanel,
  },
  props: {
    id: String,
  },
  data() {
    return {
      key: 0, // main transaction update key
      // printing: false,
      loadingDelivery: false, // set to true later
      updating: false,
      t: null,
      showEditPanel: false,
      showAdvancedOptions: false,
      showFees: false,
      orderCount: null,
      showCustomerPhone: false,
      showDriverPhone: false,
      showDelivery: false,
      showEnterWeight: false,
      weightItem: null,
      showEditItem: false,
      editingItem: null,
      transaction: null,
      z: 0,
      y: 0, // for toggle item complete
      w: window.innerWidth * (2 / 3) < 500 ? window.innerWidth * (2 / 3) : 450, //window.innerWidth - 44,
      lang: this.$store.state.language,
      isPulse: true, // pulse slider until slid
      eta: 5, // default eta could be set in commerce workflow
      etas: [5, 10, 15, 20, 30, 40, 50, 60, 75, 90, 120, 180],
      retryCount: 0,
      iosTrigger: { a: false, b: false },
      showPics: false,
      showStaffNotes: false,
      showDescriptions: false,
      isSubmitted: false, // block clicks while submitting
      placeholderPic: this.$store.state.menuItemPlaceholderPic,
      showEditOrder: false,
      // newItemName: null,
      manualItemName: null,
      manualItemPrice: null,
      manualItemQuantity: null,
      editingOutOfStock: false,
      showTest: true, // used to hide `this is a test order`
      showOrderConfirmationReminder: false,
      confirmationReminderCount: 0,
      completedItems: {},
      showAdvanceOrderInfo: false,
      loginCallback: "COMMERCE_AGENT_ORDER_LOGIN_CALLBACK",
    };
  },
  computed: {
    superuser() {
      return this.$store.getters.isSuperUser;
    },
    shopAllowedToRequestDriver() {
      if (!this.fulfilmentTime) return true;
      var now = new Date();
      var createdAt = new Date(this.t.created_at);
      var minutes = (now.getTime() - createdAt.getTime()) / (1000 * 60);
      if (minutes < 15) return false;
      return true;
    },
    fulfilmentTime() {
      if (!this.t.data.order.fulfilment_time) return null;
      var str = this.t.data.order.fulfilment_time; // "13:15" in local time of shop, assume TH
      var hours = str.split(":")[0];
      var minutes = str.split(":")[1];
      var fulfilmentTime = new Date();
      fulfilmentTime.setHours(hours);
      fulfilmentTime.setMinutes(minutes);
      return fulfilmentTime;
    },
    advanceOrderPickupTime() {
      if (!this.fulfilmentTime) return null;
      if (!this.isDelivery) return this.hhmmTime(this.fulfilmentTime);
      if (!this.t.data.fare) return null; // shouldn't happen if has fulfilment_time
      var drivingMins = this.estimatedDrivingDuration; // TODO compute
      var pickupTime = this.fulfilmentTime.getTime() - 1000 * 60 * drivingMins;
      return this.hhmmTime(pickupTime);
    },
    requestDriverTime() {
      if (!this.fulfilmentTime) return null;
      if (!this.t.data.fare) return null; // shouldn't happen if has fulfilment_time
      var drivingMins = this.estimatedDrivingDuration; // TODO compute
      var requestTime =
        this.fulfilmentTime.getTime() - 1000 * 60 * (drivingMins + 20);
      return this.hhmmTime(requestTime);
    },
    estimatedDrivingDuration() {
      if (!this.t.data.fare) return null;
      var km = this.t.data.fare.distance / 1000;
      var minutes = km * 2 + 5; // 2 minutes per km plus 5 minutes buffer
      if (minutes < 15) minutes = 15;
      return minutes;
    },
    showDeliveryDetails() {
      if (!this.t.delivery) return false;
      var hoursAgo = this.hoursAgo(this.t.delivery.updated_at);
      return hoursAgo < 24;
    },
    fulfilmentText() {
      return this.$t(`commerce.${this.t.data.type}`);
    },
    fulfilmentDiscount() {
      return this.t.data.order.fulfilment_discount || 0;
    },
    showCancel() {
      return this.t.is_ongoing || this.superuser;
    },
    allowCancel() {
      if (this.superuser) return true;
      if (!this.t.is_ongoing) return false;
      // otherwise it's ongoing, allow cancel unless driver has picked it up
      if (this.t.delivery) {
        if (this.t.delivery.state === "enroute") return false;
      }
      return true;
    },
    changeFor() {
      return this.t.data.order.change_for;
    },
    ref() {
      if (this.t.data.ref_prefix) {
        return this.t.data.ref_prefix + this.t.data.ref;
      }
      return "#" + this.t.data.ref;
    },
    isSOL() {
      if (!this.t.data.order) return false;
      return this.t.data.order.payment_method === "sol";
    },
    isPaid() {
      if (this.t.data.order.payment_method === "card") return true;
      return false;
    },
    isFailedOrder() {
      var states = ["timed_out", "cancelled_by_shop", "cancelled_by_customer"];
      return states.includes(this.t.state);
    },
    isAgentOrder() {
      return this.t.data.is_agent_order;
    },
    isIOS() {
      return true;
    },
    iosClassA() {
      if (this.iosTrigger.a) return "fa fa-circle fa-2x has-text-success";
      return "far fa-circle fa-2x has-text-ccc";
    },
    iosClassB() {
      if (this.iosTrigger.b) return "fa fa-circle fa-2x has-text-success";
      return "far fa-circle fa-2x has-text-ccc";
    },
    iosA() {
      if (this.iosTrigger.a) return "color:lightgreen";
      return "color:lightgrey";
    },
    iosB() {
      if (this.iosTrigger.b) return "color:lightgreen";
      return "color:lightgrey";
    },
    state() {
      var data = this.t.data;
      // for autoconfirm it won't be confirmed if shop cancelled etc
      if (this.t.is_ongoing && data.autoconfirm && !data.event_confirmed) {
        return "initiated";
      }
      return this.t.state;
    },
    basketItems() {
      return this.t.data.order.basket.items;
    },
    languages() {
      // new way check the languages in the commerce workflow json
      if (this.workflow) return this.workflow.data.languages || ["en", "th"];
      // if (languages && languages.length) return languages; }
      // old way check languages object on first item to get languages set to true
      if (this.basketItems.length === 0) return [];
      var obj = this.basketItems[0].item.languages;
      if (!obj) return [];
      return Object.keys(obj).filter((k) => {
        return obj[k];
      });
    },
    isTest() {
      if (!this.orderNotes || !this.showTest) return false;
      return this.orderNotes.includes("TEST ORDER");
    },
    orderNotes() {
      return this.t.data.order.basket.notes;
    },
    deliveryNotes() {
      if (!this.t.data.address) return null;
      return this.t.data.address.notes;
    },
    deliverySubsidy() {
      return this.t.data.order.delivery_subsidy || 0;
    },
    remitAmount() {
      return this.t.data.order.remit || 0;
    },
    serviceFeeAdjustment() {
      return this.t.data.service_fee_adjustment || 0;
    },
    specialDiscount() {
      return this.t.data.order.special_discount || 0;
    },
    // for TUKExpress order to show customer
    customerTotalAgentMode() {
      var orderValue = this.t.data.order.order_value;
      if (this.t.data.type === "delivery") {
        if (!this.t.data.delivery.is_free_delivery) {
          return orderValue + this.clientCash; //this.t.data.fare.price; // customer paying for delivery
        }
      }
      return orderValue; // shop paying for delivery or not a delivery
    },
    // delivery fee amount paid by customer
    clientCash() {
      return this.t.data.fare.client || this.t.data.fare.cash; // for backward compatability
    },
    vat() {
      return this.t.data.order.vat || 0;
    },
    orderValue() {
      // add fees and discounts
      var discounts = this.specialDiscount + this.fulfilmentDiscount;
      var orderValue = this.t.data.order.order_value + this.vat - discounts;
      if (this.t.data.type === "delivery") {
        var deliveryFee = this.t.data.fare.price;
        if (this.lalamoveFee) orderValue += deliveryFee;
        // if (this.t.data.delivery.is_free_delivery) orderValue -= deliveryFee; // June26
        orderValue -= this.deliverySubsidy; // was else if
        orderValue -= this.remitAmount;
      }
      return orderValue; // non delivery just return orderValue
    },
    // shows as "service fee" to shop
    deliveryFee() {
      if (this.t.data.type !== "delivery") return 0; // don't need this check now
      // if (this.t.data.delivery.is_free_delivery) return this.t.data.fare.price; // June26
      // if (this.deliverySubsidy) this.deliverySubsidy;
      return this.deliverySubsidy;
    },
    serviceFee() {
      if (this.t.data.type !== "delivery") return 0; // don't need this check now
      return this.deliverySubsidy + this.remitAmount + this.specialDiscount;
    },
    // only used by lalamove orders for now
    netFeesAndDiscounts() {
      var fees = this.t.data.order;
      var serviceFee = fees.delivery_subsidy + fees.special_discount;
      var discounts = fees.fulfilment_discount;
      var net = -1 * (serviceFee + discounts);
      if (!this.lalamoveFee) return net;
      return net + this.lalamoveFee;
    },
    lalamoveFee() {
      if (this.t.data.type !== "delivery") return null;
      if (!this.t.data.delivery.lalamove) return null;
      return this.t.data.fare.price;
    },
    currency() {
      var country = "th"; // default country
      if (this.t.data.business) country = this.t.data.business.country;
      return this.currencySymbol(country); // should store in order
    },
    slideText() {
      return "Slide to confirm";
    },
    confirmedText() {
      return "Confirmed";
    },
    isNew() {
      return this.state === "initiated";
    },
    role() {
      return this.$store.getters.getCommerceAgentRole;
    },
    workflow() {
      return this.role.workflow; // commerce() workflow
    },
    showConfirmationReminder() {
      if (!this.workflow) return true;
      if (!this.workflow.data.agent_options) return true;
      var agentOptions = this.workflow.data.agent_options;
      return agentOptions.confirmation_popup !== "hide";
    },
    longPrepTime() {
      var prepTimes = this.basketItems
        .map((i) => i.item.prep_time)
        .filter((t) => t);
      if (!prepTimes.length) return null;
      return Math.max(...prepTimes);
    },
    showPrepTimeSelector() {
      //   return true;
      if (!this.workflow) return null;
      // actually prep_time object should have show: t/f bool, so you can set default separately
      if (this.longPrepTime) return true;
      if (this.workflow.data.prep_time) return true; // use prep_time: {} object instead
      return this.workflow.data.prep_time_selector; // deprecate this
    },
    prepTimeDefault() {
      if (this.longPrepTime) return this.longPrepTime;
      if (!this.workflow) return this.eta;
      if (this.workflow.data.prep_time) {
        return this.workflow.data.prep_time.default || this.eta; // new way
      }
      return this.workflow.data.prep_time_default || this.eta; // old way
    },
    isRequestingDriver() {
      if (!this.t.delivery) return false;
      var dt = this.t.delivery; // delivery transaction
      if (!dt.driver && dt.state === "initiated") return true;
      return false;
    },
    isRequestAgain() {
      if (!this.t.delivery) return false;
      var dt = this.t.delivery; // delivery transaction
      if (!dt.driver && dt.state !== "initiated") return true;
      return false;
    },
    customerName() {
      // if (this.t.customer.name === "") return this.t.customer.phone_number;
      // return this.shortenString(this.t.customer.name, 20);
      return this.t.customer.name || this.t.customer.phone_number;
    },
    driverName() {
      return this.t.delivery.driver.name || this.t.delivery.driver.phone_number;
    },
    basketItemCount() {
      // if (!this.basket) return 0;
      var sum = 0;
      this.basketItems.forEach((o) => {
        sum = sum + this.actualQuantity(o); //o.quantity;
      });
      return sum;
    },
    isDelayedDelivery() {
      return this.t.data.delivery.type === "delayed";
    },
    deliveryDelayDuration() {
      return this.t.data.delivery.delay_duration;
    },
    isThirdPartyDelivery() {
      return this.t.data.delivery.type === "third-party";
    },
    prettyState() {
      if (this.state === "initiated")
        return this.$t("ecommerce.waiting-for-confirmation");
      if (this.state === "confirmed")
        return this.$t("ecommerce.being-prepared");
      if (this.state === "ready")
        return this.$t("ecommerce.waiting-for-pickup"); // if take-away
      if (this.state === "completed") return this.$t("ecommerce.completed");
      if (this.state === "timed_out") return this.$t("ecommerce.expired");
      if (this.state === "cancelled_by_shop")
        return this.$t("ecommerce.shop-cancelled");
      if (this.state === "cancelled_by_customer")
        return this.$t("ecommerce.customer-cancelled");
      return this.state;
    },
    stateClass() {
      var tagClass = "is-dark";
      if (this.state === "initiated") tagClass = "is-danger";
      if (this.state === "confirmed") tagClass = "is-warning";
      if (this.state === "ready") tagClass = "is-orange";
      if (this.state === "completed") tagClass = "is-success";
      if (this.state === "cancelled_by_shop") tagClass = "is-danger";
      if (this.state === "cancelled_by_customer") tagClass = "is-danger";
      if (this.state === "timed_out") tagClass = "is-danger";
      return tagClass;
    },
    isDelivery() {
      // don't show delivery stuff if order timed out or cancelled_by_shop
      if (this.isFailedOrder) return false;
      return this.t.data.type === "delivery";
    },
    isTakeaway() {
      return this.t.data.type === "take-away";
    },
    isDinein() {
      return this.t.data.type === "dine-in";
    },
    deliveryState() {
      if (!this.t.delivery) return "None";
      var state = this.t.delivery.state;
      return this.translateState(state);
    },
    fulfilmentIcon() {
      var type = this.t.data.type;
      if (type === "take-away") return "fa-walking  has-text-link";
      if (type === "delivery") return "fa-shipping-fast";
      if (type === "dine-in") return "fa-users has-text-orange";
      return "fa-question has-text-danger";
    },
    fulfilmentType() {
      return this.translateFulfilmentType(this.t.data.type);
    },
    orderID() {
      var id = this.t.id;
      return id.substr(id.length - 5);
    },
    swipe() {
      var obj = null;
      if (this.state === "initiated") {
        obj = {
          text: this.$t("ecommerce.order-confirmed-?"),
          successText: this.$t("ecommerce.confirmed"),
          background: this.bulmaColor("primary"),
        };
      }
      if (this.state === "confirmed") {
        obj = {
          text: this.$t("ecommerce.ready-for-pickup-?"),
          successText: this.$t("ecommerce.ready"),
          background: this.bulmaColor("info"),
        };
      }
      if (this.state === "ready") {
        obj = {
          text: this.$t("ecommerce.order-completed-?"),
          successText: this.$t("ecommerce.completed"),
          background: this.bulmaColor("warning"),
        };
      }
      return obj;
    },
    receiptPrice() {
      if (!this.t.delivery) return null;
      return this.t.delivery.data.receipt_price;
    },
    promoCode() {
      if (!this.t.data.delivery) return null;
      return this.t.data.delivery.promo_code;
    },
    driverProfilePic() {
      return this.t.delivery.driver.profile_pic_url || this.fallbackProfPic();
    },
    driverVehicleNumber() {
      if (!this.t.delivery.driver.role) return "DELETED"; // driver with deleted role
      return this.t.delivery.driver.role.data.vehicle_number;
    },
  },
  mounted() {
    if (!this.role) {
      this.checkLogin();
      return;
    }
    // FIRST check user has the necessary commerce agent role to view this order
    // this.onVisibilityChange();
    document.addEventListener("visibilitychange", this.reinit);
    // EventBus.$on("CLOSE_ORDER_DETAILS", () => this.close());
    this.init(); // this.getCommerceAgentOrder();

    // EventBus.$on(this.loginCallback, () => this.refreshPage());
    EventBus.$on(this.loginCallback, () => this.goHome());
  },
  beforeDestroy() {
    document.removeEventListener("visibilitychange", this.reinit);
    EventBus.$off(this.loginCallback);
  },
  methods: {
    init() {
      if (this.$route.name !== "commerce-agent-order") return; // try to fix bug
      var id = this.$route.params.id;
      if (id) this.getCommerceAgentOrder(id); // fix bug
    },
    reinit() {
      this.iosTrigger = { a: false, b: false };
      if (document.visibilityState === "visible") this.init();
    },
    forceUpdate() {
      console.log("forceUpdate");
    },
    editWeight(o) {
      this.weightItem = o;
      this.showEnterWeight = true;
    },
    openDeliveryAddress() {
      var lat = this.t.data.address.lat;
      var lon = this.t.data.address.lon;
      var googleMapURL = `http://www.google.com/maps/place/${lat},${lon}`;
      window.open(googleMapURL, "_blank");
    },
    showPaymentInfo() {
      var method = this.translatePayment(this.t.data.order.payment_method);
      var msg = `Customer will pay driver<br>via <b>${method}</b>`;
      this.infoToast(msg, "top");
    },
    removeItemInfo() {
      this.errorToast("Click the trash can<br>to remove an item 🗑");
    },
    openDeliveryDetails() {
      // TODO
    },
    print() {
      // this.$toast.clear(); // close all toasts
      // this.$nextTick(() => window.print());
      window.print();
    },
    triggerShowEditPanel() {
      this.showEditPanel = true;
      if (this.t.state === "initiated") this.changeToAutoconfirm();
    },
    ///////////////// ----------------------- ////////////////
    editTukDiscount() {
      var tukDiscount = this.t.data.order.tuk_discount || 0;
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-percentage'></i>&nbsp;Add TUK Discount<p/>
        <p style='margin-bottom:10px'>This edits the TUK Discount on commerce order.</p>
        <p><i>Current TUK Discount: <b>${tukDiscount}</b></i></p>
        </div>`,
        input: "text",
        inputPlaceholder: "฿100",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Add TUK Discount",
        inputValidator: (val) => {
          if (!val || parseInt(val) < 0) return "Enter a discount >= 0";
        },
      }).then((val) => {
        if (!val.value) return;
        var discount = parseInt(val.value);
        this.infoToast("Setting TUK Discount to ฿" + discount);
        var data = {
          id: this.t.id,
          discount: discount,
        };
        var loader = this.loadingDots("orange");
        this.$store
          .dispatch("addTukDiscountToOrder", data)
          .then(() => this.successToast("Success!"))
          .catch((err) => this.apiError(err))
          .finally(() => loader.hide());
      });
    },
    //////////// --------- example above ----------- ////////////////
    editServiceFee() {
      if (!this.superuser) return;
      var serviceFee = this.remitAmount + this.deliverySubsidy + this.serviceFeeAdjustment;
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-pencil-alt fa-sm'></i>&nbsp;Adjust Service Fee</p>
        <p style='margin-bottom:10px'>You can adjust the service fee up to the remit amount:</p>
        <p style='font-size:0.9em; margin-top:8px'>Adjust Service Fee
        <b style='color:red'>-฿${this.serviceFeeAdjustment}</b></p>
        <p>Remit Amount&nbsp;&nbsp;&nbsp;&nbsp;
        <b>฿${this.remitAmount}</b></p>
        <p>Delivery Subsidy
        <b>฿${this.deliverySubsidy}</b></p>
        <p>-------------------------</p>
        <p style='font-size:1.1em'>Service Fee&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <b>฿${serviceFee}</b></p>
        </div>`,
        input: "number",
        inputPlaceholder: "-฿100",
        inputValidator: (val) => {
          if (!parseInt(val) && val !== "0") return "Enter a number";
          if (parseInt(val) < -1 * this.remitAmount) return `Enter a number > -${this.remitAmount}`;
        },
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Adjust",
      }).then((val) => {
        if (!val.value) return;
        var adjustment = parseInt(val.value);
        this.infoToast("TODO adjust service fee by ฿" + adjustment);
        var data = {
          id: this.t.id,
          adjustment: adjustment,
        };
        var loader = this.loadingDots("orange");
        this.$store
          .dispatch("addServiceFeeAdjustmentToOrder", data)
          .then(() => this.successToast("Success!"))
          .catch((err) => this.apiError(err))
          .finally(() => loader.hide());
      });
    },
    // updateCommerceRemit(newRemit) {
    //   var loader = this.loadingDots();
    //   this.$store
    //     .dispatch("updateCommerceRemit", this.t.id)
    //     .then(() => { })
    //     .catch((err) => this.apiError(err))
    //     .finally(() => loader.hide());
    // },
    changeToAutoconfirm() {
      var loader = this.loadingDots();
      this.$store
        .dispatch("changeCommerceOrderToAutoconfirm", this.t.id)
        .then(() => {
          var msg = `Order is autoconfirmed<br>Please click confirm or cancel`;
          this.infoToast(msg);
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    checkLogin() {
      var msg = this.$t("login.login-to-see-your-orders"); // this doesn't do anything, msg not used for sms login
      if (!this.smsLoginOkay(msg, this.loginCallback)) return;
    },
    copy(txt) {
      this.$copyText(txt);
      this.infoToast("Copied to clipboard!<br>" + txt);
    },
    closeOrderConfirmationReminder() {
      this.showOrderConfirmationReminder = false;
      this.confirmationReminderCount += 1;
    },
    infoCallCustomerDeliveryTime() {
      var msg = `If the order takes more than 45 mins<br>to prepare please call the customer<br>to arrange a convenient delivery time`;
      this.infoToast(msg, "top", 10 * 1000);
    },
    infoConfirmRequestDriver() {
      var msg = `When you confirm the order we call a driver<br>They will arrive in about 20 minutes`;
      this.infoToast(msg, "top", 10 * 1000);
    },
    infoDelayedRequestDriver() {
      var msg = `Request driver 20 minutes before<br>the order is ready for pickup.`;
      this.infoToast(msg, "top", 10 * 1000);
    },
    infoRequestingDriver() {
      var msg = `It can take 20+ minutes<br>to get a driver during peak hours`;
      this.infoToast(msg, "top", 10 * 1000);
    },
    copyDeliveryID() {
      this.$copyText(this.t.delivery.id);
      this.successToast("Copied delivery ID");
    },
    messageAgents() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em'><i class='fa fa-paper-plane'></i>&nbsp;Message Commerce Agents</p>
        <p style='margin-top:10px'>Send push notification to the shop's commerce agents</p>
        </div>`,
        showCloseButton: true,
        confirmButtonText: "Send Message",
        input: "textarea",
        inputValue: `TUK Order ${this.ref} - Please confirm!!! CLICK or SLIDE to accept order and request driver 🏍`,
        inputValidator: (val) => {
          if (!val || val.length < 4) return "Enter a message";
        },
      }).then((val) => {
        if (val.value) {
          var data = {
            workflow_id: this.t.workflow_id,
            title: `🚨TUK NEW ORDER🚨 #${this.ref}`,
            message: val.value,
          };
          var loader = this.loadingDots();
          this.$store
            .dispatch("sendMessageToWorkflow", data)
            .then(() => this.successToast("Sent!"))
            .catch((err) => this.apiError(err))
            .finally(() => loader.hide());
        }
      });
    },
    alertIfFinished() {
      if (this.t.state === "cancelled_by_customer") {
        let msg = this.$t("ecommerce.customer-cancelled-this-order") + "!";
        this.errorToast(msg, "top");
      }
      if (this.t.state === "cancelled_by_shop") {
        let msg = this.$t("ecommerce.shop-cancelled-this-order") + "!";
        this.errorToast(msg, "top");
      }
      if (this.t.state === "timed_out") {
        let msg = this.$t("ecommerce.this-order-expired") + "!";
        this.errorToast(msg, "top");
      }
      if (this.t.state === "completed") {
        let msg = this.$t("ecommerce.this-order-is-finished") + "!";
        this.successToast(msg, "top");
      }
    },
    getCommerceAgentOrder(id) {
      if (!id) this.errorToast("getCommerceAgentOrder requires id");
      this.updating = true;
      this.$store
        .dispatch("getPartialCommerceOrderForAgent", id) // "getCommerceOrderForAgent"
        .then((res) => {
          this.t = res.data; // must be a commerce order
          if (!this.isCommerceOrder()) return;
          if (this.isDelivery) this.getCommerceDelivery(id);
          setTimeout(() => this.alertIfFinished(), 1500);
          // setTimeout(() => this.checkAutoconfirm(), 4000);
          this.updateTimer();
          this.getCommerceOrderCount();
          this.logCommerceAgentViewedNewOrder();
          this.$nextTick(() => (this.key += 1));
          this.eta = this.prepTimeDefault;

          if (this.state === "initiated")
            this.showOrderConfirmationReminder = true;
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.updating = false));
    },
    getCommerceDelivery(id) {
      this.loadingDelivery = true;
      this.$store
        .dispatch("getCommerceDelivery", id)
        .then((res) => {
          this.t.delivery = res.data; // this.t must already be set
          this.$nextTick(() => (this.key += 1));
        })
        .catch((err) => {
          var shop = this.t.data.business.name;
          var msg = `🚨 ERR getCommerceDelivery @ ${shop} ${this.ref}`;
          this.sendSuperuserNotification(msg);
          this.apiError(err);
        })
        .finally(() => (this.loadingDelivery = false));
    },
    checkAutoconfirm() {
      if (!this.superuser) return; // only shows to superusers
      if (
        this.t.data.autoconfirm &&
        !this.t.data.event_preconfirm &&
        this.t.is_ongoing
      ) {
        var msg = `Autoconfirmed requires confirmation!`;
        this.warningToast(msg, "bottom", 6000);
      }
    },
    isCommerceOrder() {
      if (this.t.workflow_type_name === "Commerce") return true;
      if (this.t.workflow_type_name === "Delivery") {
        var commerceOrderID = this.t.data.commerce_transaction_id;
        this.getCommerceAgentOrder(commerceOrderID);
        return;
      }
      var msg = `Error: Not Commerce or Delivery<br>[ ${this.t.workflow_type_name} ]`;
      this.errorToast(msg, "top", 20000);
      return false;
    },
    logCommerceAgentViewedNewOrder() {
      if (this.state !== "initiated") return; // computed var that handles autoconfirm
      this.log("commerce_agent_viewed_new_order", {
        business: this.t.data.business.name,
        user: this.$store.getters.realName,
        phone: this.$store.getters.phoneNumber,
        ref: this.ref,
        transaction_id: this.t.id,
      });
    },
    updateTimer() {
      setTimeout(() => this.init(), 60 * 1000);
    },
    onVisibilityChange() {
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "hidden") return;
        this.init();
      });
    },
    gotoCustomerOrder() {
      this.goto("/commerce_order/" + this.t.id);
    },
    enterThirdPartyTrackingLink() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em'>
        <i class='fa fa-link'></i>&nbsp;Input Third-Party Tracking Link</p>
        </div>`,
        input: "url",
        inputPlaceholder: "https://thaipost.com/track/abc123",
        showCancelButton: true,
        confirmButtonText: this.$t("submit"),
        inputValidator: (val) => {
          if (!val || val.length < 5) return "Enter a valid URL";
        },
      }).then((val) => {
        if (val.value) {
          //
        }
      });
    },
    closeEditOrder() {
      this.showEditOrder = false;
    },
    startEditOrderAdd() {
      this.showEditOrder = true;
      this.isEditDiscount = false;
    },
    startEditOrderDiscount() {
      this.showEditOrder = true;
      this.isEditDiscount = true;
    },
    toggleMenuInfo() {
      this.showPics = !this.showPics;
      this.showDescriptions = !this.showDescriptions;
      this.showStaffNotes = !this.showStaffNotes;
    },
    computeSlideWidth() {
      var w = window.innerWidth * (2 / 3); //window.innerWidth - 44; // in case window changed size
      if (w < 500) this.w = w;
      else this.w = 500;
    },
    incrementOrderNumber() {
      if (!this.superuser) return;
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
          <i class='fa fa-ticket-alt'></i>&nbsp;
          Order ${this.ref}
        </p>
        <p>Click <strong>Increment</strong> to change the order number.</p>
        </div>`,
        showCloseButton: true,
        confirmButtonText: "Increment",
      }).then((val) => {
        if (val.value) {
          var loader = this.loadingDots();
          this.$store
            .dispatch("incrementCommerceOrder", this.t.id)
            .then(() => {
              this.successToast("Increment success!");
              this.updateOrdersCommerceAgent(true);
              setTimeout(() => this.close(), 800);
            })
            .catch((err) => this.apiError(err))
            .finally(() => loader.hide());
        }
      });
    },
    orderCountInfo() {
      var msg = `This customer is ordering<br>from you for the first time!`;
      if (this.orderCount) {
        msg = `This customer has ordered<br>from you ${this.orderCount} times!`;
      }
      this.successToast(msg, "top");
      setTimeout(() => {
        if (this.superuser) this.goto(`user_info/${this.t.customer.id}`);
      }, 700);
    },
    getCommerceOrderCount() {
      var payload = {
        workflowID: this.t.workflow_id,
        userID: this.t.created_by,
      };
      this.$store
        .dispatch("getCommerceOrderCount", payload)
        .then((res) => {
          // console.log("getCommerceOrderCount", res.data);
          this.orderCount = res.data;
        })
        .catch((err) => this.apiError(err));
    },
    hasOptions(o) {
      if (!o.item.options) return false;
      return o.item.options.length;
    },
    shareToCustomer() {
      var path = "/commerce_order/" + this.t.id;
      if (this.t.data.short_id) path = "/o/" + this.t.data.short_id;
      var url = window.location.origin + path;
      this.$copyText(url);
      if (!navigator.share) {
        var msg = `Order share link copied to clipboard<br>${url}`;
        this.infoToast(msg, "top");
        return;
      }
      var shareMsg = `🛺 Here's your TUK App order for ${this.t.data.business.name}
👉🏼 ${url}`;
      navigator
        .share({ text: shareMsg })
        .catch((err) => this.console("Error sharing", err));
    },
    copyOrderID() {
      this.$copyText(this.t.id);
      this.infoToast(`Copied Order ID<br>${this.t.id}`);
    },
    preClose() {
      // if (this.state === "initiated") this.remindToConfirmOrder({ val: true });
      if (this.state === "initiated" && !this.superuser) {
        if (this.confirmationReminderCount < 2) {
          this.showOrderConfirmationReminder = true;
        } else {
          var line1 = this.$t("commerce.please-confirm-order-asap");
          var line2 = this.$t("commerce.it-will-expire");
          var msg = `${line1}<br>${line2}`;
          setTimeout(() => this.errorToast(msg, "top", 1000 * 10), 1000);
          this.close();
        }
      } else this.close();
    },
    close() {
      if (this.superuser) {
        if (window.history.length <= 2) return this.goto("ecommerce");
        this.$router.go(-1);
      } else {
        this.goto("ecommerce");
      }
    },
    remindToConfirmOrder(close) {
      if (this.state !== "initiated") return;
      console.log("remindToConfirmOrder", this.state, this.t);
      var title = this.$t("commerce.accept-order");
      var text1 = this.$t("commerce.is-your-shop-open-now");
      var text2 = this.$t("commerce.if-not-cancel-order");
      this.$swal({
        html: `<div style='text-align: left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
          <i class='fa fa-exclamation'></i>&nbsp;${title} ???
        </p>
        <p style='margin-bottom:10px'>${text1}</p>
        <p><i>${text2}</i></p>
        </div>`,
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: this.bulmaColor("success"),
        confirmButtonText: this.$t("accept"),
        cancelButtonText: this.$t("i-dont-know"),
      }).then((val) => {
        if (val.value) this.done();
        else {
          if (close.val) {
            var line1 = this.$t("commerce.please-confirm-order-asap");
            var line2 = this.$t("commerce.it-will-expire");
            var msg = `${line1}<br>${line2}`;
            setTimeout(() => this.errorToast(msg, "top", 1000 * 10), 1000);
            this.close();
          }
        }
      });
    },
    toggleEditingOutOfStock() {
      this.editingOutOfStock = !this.editingOutOfStock;
      this.showEditOrder = false;
    },
    preRemoveItem(o) {
      if (o.out_of_stock) {
        return this.resetOutOfStockItem(o);
      }
      var red = this.bulmaColor("danger");
      var title = this.$t("ecommerce.remove-item");
      var itemName = `*<b>${o.item.name}<b>*`;
      var howMany = "";
      if (o.quantity > 1) {
        itemName = `${o.quantity} x ${itemName}`;
        howMany = `<p>How many to remove?</p>`;
      }
      var html = `<div style='text-align:left'>
        <p style="margin-bottom:12px; font-size:1.2em">
            <i class='far fa-trash-alt fa-sm'></i>&nbsp;${title}
        </p>
        <p style='font-size:1.4em; margin-bottom:10px'>${itemName}</p>
        <p style='margin-bottom:10px'>Click CONFIRM to remove this item from the order.</p>
        <p style='margin-bottom:10px'>Remember to call the customer to tell them the item is out of stock.</p>
        ${howMany}
        </div>`;

      var swalOpts = {
        html: html,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonColor: red,
        confirmButtonText: this.$t("confirm"),
      };
      if (o.quantity > 1 && !this.isSpecialItem(o)) {
        swalOpts.input = "number";
        swalOpts.inputValue = parseInt(o.quantity);
        swalOpts.inputValidator = (val) => {
          if (val > o.quantity || val <= 0)
            return "Enter number between 1 - " + o.quantity;
        };
        // swalOpts.html += `<p>Enter number of items to remove (up to ${o.quantity})</p>`;
      }
      this.$swal(swalOpts).then((val) => {
        if (val.value) {
          if (this.isSpecialItem(o)) this.removeSpecialItem(o);
          else if (o.quantity > 1) this.removeOutOfStockItem(o, val.value);
          else this.removeOutOfStockItem(o);
        }
      });
    },
    resetOutOfStockItem(o) {
      o.out_of_stock = 0;
      this.t.data.order.order_value = this.basketValue(); // update the order value
      this.submitOrderEdit();
      this.toggleEditingOutOfStock();
    },
    removeSpecialItem(o) {
      // remove item for real, only special item with ID like ~abc
      var idx = this.basketItems.findIndex((i) => i.item.id === o.item.id);
      console.log("removeSpecialItem", o.id, idx, o);
      if (idx === -1) return this.errorToast("Invalid array index");
      this.basketItems.splice(idx, 1); // removes basket item at index
      this.t.data.order.order_value = this.basketValue(); // update the order value
      this.submitOrderEdit();
      this.toggleEditingOutOfStock();
    },
    removeOutOfStockItem(o, newQuantity) {
      var quantity = parseInt(o.quantity);
      if (newQuantity) quantity = parseInt(newQuantity); // new quantity set if o.quantity > 1
      o.out_of_stock = quantity; // 2023-08-13 new way to track out of stock removals
      // var manualItem = {
      //   id: "~" + shortid.generate(), // needs a random ID, stat with ~
      //   name: "[Out of Stock] " + o.item.name, // [REMOVE]
      //   price: -1 * parseInt(this.discountedTotalPrice(o.item)),
      //   description: "Removed out of stock",
      // };
      // // change push to unshift
      // this.basketItems.unshift({
      //   item: manualItem,
      //   quantity: quantity, //parseInt(o.quantity),
      // }); // this.addToBasket(manualItem);
      this.t.data.order.order_value = this.basketValue(); // update the order value
      this.submitOrderEdit();
      this.toggleEditingOutOfStock();
    },
    addManualItem() {
      if (!this.manualItemName || !this.manualItemPrice) {
        this.infoToast("Enter item name and price", "top");
        return;
      }
      if (!this.manualItemQuantity) this.manualItemQuantity = 1;
      var price = parseInt(this.manualItemPrice);
      if (this.isEditDiscount) {
        price = -1 * Math.abs(price);
        this.manualItemName = `[DISCOUNT] ` + this.manualItemName;
      } else {
        this.manualItemName = `[ADD] ` + this.manualItemName;
      }
      var manualItem = {
        id: "~" + shortid.generate(), // needs a random ID, stat with ~
        name: this.manualItemName,
        price: price,
        description: "Added by shop",
      };
      // change push to unshift
      this.basketItems.unshift({
        item: manualItem,
        quantity: parseInt(this.manualItemQuantity),
      }); // this.addToBasket(manualItem);
      this.t.data.order.order_value = this.basketValue(); // update the order value
      this.submitOrderEdit();
    },
    editItemWeight(weight) {
      this.weightItem.weighed = true;
      this.weightItem.item.actual_weight = weight; // grams
      this.t.data.order.order_value = this.basketValue(); // update the order value
      this.submitOrderEdit();
    },
    basketValue() {
      var basket = this.t.data.order.basket;
      var value = 0;
      basket.items.forEach((o) => {
        value = value + this.discountedTotalPrice(o.item) * this.actualQuantity(o); // o.quantity;
      });
      return value;
    },
    editItem(o) {
      if (o.newPrice) {
        this.editingItem.item.price = o.newPrice;
      }
      if (o.newName) {
        this.editingItem.item.name = o.newName;
        this.languages.forEach((l) => {
          if (this.editingItem.item[l])
            this.editingItem.item[l].name = o.newName;
        });
      }
      this.t.data.order.order_value = this.basketValue(); // update the order value
      this.submitOrderEdit();
    },
    triggerEditItem(o) {
      if (this.editingOutOfStock && this.superuser) {
        this.editingItem = o;
        this.showEditItem = true;
      }
    },
    resetOrderEdit() {
      this.manualItemName = null;
      this.manualItemPrice = null;
      this.manualItemQuantity = null;
      this.showEditOrder = false;
    },
    submitOrderEdit() {
      var loader = this.loadingDots();
      this.$store
        .dispatch("patchTransaction", {
          transactionID: this.t.id, //data.order.basket.items;
          data: {
            data: { order: this.t.data.order, edited: true }, //event_edited: true },
          },
        })
        .then(() => {
          this.resetOrderEdit();
          this.successToast("Edited order 👍🏼");
          this.updateOrdersCommerceAgent(true);
          // setTimeout(() => this.close(), 800); // is this necessary?
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    toggleItemComplete(item) {
      if (this.editingOutOfStock) return;
      var itemID = item.id2 || item.id;
      this.completedItems[itemID] = !this.completedItems[itemID];
      this.y += 1;
      console.log("completed", this.completedItems);
    },

    itemComplete(item) {
      return this.completedItems[item.id2 || item.id];
    },
    optionMenuName(o) {
      var menu = o.menu.name;
      if (o.menu[this.lang]) menu = o.menu[this.lang];
      return menu;
    },
    optionItemName(o) {
      var option = o.option.name;
      if (o.option[this.lang]) option = o.option[this.lang].name;
      return option;
    },
    isSpecialItem(o) {
      if (o.item.id && o.item.id.startsWith("~")) return true;
      return false;
    },
    // init(t) {
    //   this.transaction = t;
    //   this.eta = this.prepTimeDefault; // 5 minutes or whatever is set in workflow json
    //   this.isPulse = true;
    //   this.iosTrigger = { a: false, b: false };
    //   this.computeSlideWidth();
    //   this.z += 1;
    // },
    iosSlide(x) {
      this.iosTrigger[x] = true;
      if (this.iosTrigger.a && this.iosTrigger.b) this.done();
      sounds("collect1");
    },
    itemName(o) {
      if (o[this.lang]) {
        return o[this.lang].name;
      }
      return o.name;
    },
    itemDescription(o) {
      if (o[this.lang]) {
        return o[this.lang].description; // || "~";
      }
      return o.description; // || "~";
    },
    openNotesReminder() {
      if (!this.orderNotes) return;
      this.$swal({
        html: `<div style='text-align:left'>
            <p style='font-size:1.2em; margin-bottom:10px'>
              <i class="far fa-bell" style='color:red'></i>&nbsp;Note From Customer
            </p>
            <p><i>${this.orderNotes}</i></p>
            </div>`,
        confirmButtonText: this.$t("i-acknowledge"),
      });
    },
    done() {
      if (this.loadingDelivery && this.state !== "initiated") {
        // var shop = this.t.data.business.name;
        // var msg = `🚨 done() still loadingDelivery @ ${shop} ${this.ref} ${this.state}`;
        // this.sendSuperuserNotification(msg);
        this.infoToast("One moment please...", "top", 3000);
        setTimeout(() => this.done(), 3000);
        return;
      }
      if (!this.shopAllowedToRequestDriver) {
        var msg = `This is an Advance Order<br>Please wait until ${this.requestDriverTime}<br>To request the delivery`;
        this.warningToast(msg, "top", 9000);
        this.reinit();
        var shop = this.t.data.business.name;
        var warn = `🚨 ADVANCE ORDER requesting driver early @ ${shop} ${this.ref}`;
        this.sendSuperuserNotification(warn);
        return;
      }
      this.log("commerce_agent_swiped", this.t);
      this.isSubmitted = true; // hides buttons/slider while submitting to disallow multiple submits
      setTimeout(() => (this.isSubmitted = false), 8 * 1000); // reset buttons after 8 seconds
      if (this.state === "initiated") {
        this.openNotesReminder(); // delay a bit?
      }
      if (this.isDelivery && !this.t.delivery) {
        if (
          (this.state === "initiated" && !this.isDelayedDelivery) ||
          (this.state === "confirmed" && this.isDelayedDelivery) ||
          this.state === "confirmed"
        ) {
          return this.createDeliveryTransaction(); // create delivery first
        }
        // if (this.state === "initiated" && !this.isDelayedDelivery) {
        // return this.createDeliveryTransaction(); // create delivery first
        // } else if (this.state === "confirmed" && this.isDelayedDelivery) {
        //   return this.createDeliveryTransaction(); // create delivery first
      }
      this.isPulse = false;
      // increment order state: initiated -> confirmed, confirmed -> ready
      var state = "confirmed";
      var sound = "money";
      if (this.state === "confirmed") {
        state = "ready";
        sound = "safe";
      }
      if (this.state === "ready") {
        state = "completed";
        sound = "success";
      }
      var data = null;
      if (this.isNew) data = { prep_time: this.eta };
      sounds(sound); // play sound
      var loader = this.loadingDots("purple");
      this.$store
        .dispatch("patchTransaction", {
          transactionID: this.t.id,
          data: {
            state: state,
            handled_by: this.userID(), // should log all state changes in DB by who did it
            data: data,
          },
        })
        .then(() => {
          this.updateOrdersCommerceAgent(true);
          // setTimeout(() => this.close(), 800);
          if (this.state !== "initiated") this.close(); // it means you are in state completed now
          else setTimeout(() => this.reinit(), 800);
          this.showOrderConfirmationReminder = false; // close this...
        })
        .catch((err) => {
          this.apiError(err);
          // this.close();
          this.reinit();
          this.errorToast("Please try again 🤕");
          this.updateOrdersCommerceAgent();
        })
        .finally(() => {
          loader.hide();
          setTimeout(() => (this.isSubmitted = false), 1500); // reset this to allow submit again
        });
    },
    cancelOrder() {
      sounds("unsafe");
      var red = this.bulmaColor("danger");
      var title = this.$t("ecommerce.cancel-order") + "?";
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em'>
        <i class="fa fa-exclamation-triangle"></i>
        &nbsp;${title}
        </p>
        <p style='margin-top:12px'>
        ${this.$t("commerce.cancel-are-you-sure")}
        </p>`,
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: this.$t("yes-cancel"),
        cancelButtonColor: red,
        confirmButtonText: this.$t("no"),
        confirmButtonColor: this.bulmaColor("success"),
      }).then((result) => {
        if (result.dismiss === "cancel") {
          if (!this.allowCancel) {
            this.cannotCancelOrder();
            return;
          }
          var loader = this.loadingDots();
          this.$store
            .dispatch("patchTransaction", {
              transactionID: this.t.id,
              data: { state: "cancelled_by_shop" },
            })
            .then(() => {
              this.updateOrdersCommerceAgent(true);
              setTimeout(() => this.close(), 1000);
              this.log("order_cancelled_by_shop");
              this.pauseShopOrNot();
            })
            .catch((err) => this.apiError(err))
            .finally(() => loader.hide());
        }
      });
    },
    cannotCancelOrder() {
      this.errorToast("You cannot cancel the order");
      this.$swal({
        type: "error",
        title: "Delivery Enroute!",
        text: "To cancel this order send a message to Merchant Support!",
        animation: true,
      }).then(() => {
        this.infoToast("Opening Support Chat...");
        setTimeout(() => this.contactMerchantSupport(), 400);
        // send supers email and notification
        var shop = this.t.data.business.name;
        var msg = `🚨 Order Cancel Delivery Enroute @ ${shop} ${this.ref}`;
        this.sendSuperuserNotification(msg);
      });
    },
    pauseShopOrNot() {
      this.$swal({
        html: `<div style='text-align:left'>
  <p style='margin-bottom:12px'>
  <i class='far fa-hourglass'></i>&nbsp;Do you need to PAUSE shop?</p>
  <p>Remember to PAUSE your shop if you don't want to receive another order now.</p>
  </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonColor: this.bulmaColor("danger"),
        confirmButtonText: this.$t("pause-shop.pause"),
        cancelButtonText: this.$t("no"),
      }).then((val) => {
        if (val.value) this.pauseShop();
      });
    },
    pauseShop() {
      var loader = this.loadingDots("red");
      this.$store
        .dispatch("updateWorkflowData", {
          id: this.t.workflow_id,
          data: { paused: true },
        })
        .then(() => {
          this.successToast(this.$t("pause-shop.pause"));
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    restartOrder() {
      this.warningToast("Restart this order - coming soon!");
    },
    createDeliveryTransaction() {
      this.infoToast("👍🏼<i class='fa fa-spinner fa-spin' />", "top");
      var t = this.t;
      var pickup = {
        id: "business_address",
        name: t.data.business.name,
        lat: t.data.business.lat,
        lon: t.data.business.lon,
      };
      var dropoff = {
        id: "delivery_address",
        name: t.data.address.name,
        lat: t.data.address.lat,
        lon: t.data.address.lon,
        notes: this.deliveryNotes,
      };
      var delivery = {
        type: t.data.business.type,
        business_name: t.data.business.name,
        workflow_id: t.workflow_id,
        agent_id: this.userID(), // so you can get notified of delivery events
        order_value: this.orderValue, // + this.remitAmount,
        payment_method: t.data.order.payment_method, //"cash",
        change_for: t.data.order.change_for, // added on 20 Mar 2022
        is_free_delivery: t.data.delivery.is_free_delivery, // 22 Aug 2020
        is_flexible_pickup_location:
          t.data.delivery.is_flexible_pickup_location,
        promo_code: t.data.delivery.promo_code, // @0909588716
        contactless_note: t.data.delivery.contactless_note,
        business_note: t.data.delivery.business_note, // shop note?
        sign_name: t.data.delivery.sign_name, // business sign name if different from shop name
        delivery_subsidy: t.data.order.delivery_subsidy,
        remit: this.remitAmount, // t.data.order.remit,
        require_receipt: t.data.delivery.require_receipt,
        is_agent_order: this.isAgentOrder, // TUK Express
        is_large: t.data.delivery.is_large, // requires a large box
      };
      if (t.data.assign_driver) {
        delivery.assign_driver = t.data.assign_driver;
      }
      if (t.data.order.cashback) {
        delivery.cashback = t.data.order.cashback;
      }
      delivery.express_fleet = t.data.delivery.express_fleet;
      if (t.data.delivery.fallback_fleet) {
        delivery.fallback_fleet = t.data.delivery.fallback_fleet;
      }
      if (t.data.delivery.lalamove) {
        delivery.lalamove = t.data.delivery.lalamove;
        delivery.lalamove.tuk_order_ref = t.data.ref; // change to computed ref?
      }
      var obj = {
        type: "delivery",
        pickup_stop: pickup,
        dropoff_stop: dropoff,
        fare: t.data.fare,
        ref: t.data.ref, // reference number
        ref_prefix: t.data.ref_prefix, // optional
        delivery: delivery,
        commerce_transaction_id: this.t.id, // so we can link back to original commerce txn
        commerce_created_at: this.t.created_at,
        coords_created: this.t.data.coords_created,
      };
      if (t.data.delivery.reversed) {
        obj.pickup_stop = dropoff;
        obj.dropoff_stop = pickup;
      }
      if (t.data.delivery.predicted_route) {
        obj.predicted_route = t.data.delivery.predicted_route;
      }
      if (t.data.gift_details) {
        obj.gift_details = t.data.gift_details;
      }
      if (this.eta > 15) {
        var now = new Date();
        var scheduledTime = new Date(now.getTime() + 60000 * this.eta);
        obj.scheduled_time = scheduledTime.toISOString();
      }
      if (this.workflow.data.driver_blacklist) {
        obj.driver_blacklist = this.workflow.data.driver_blacklist;
      }
      this.$store
        .dispatch("createTransaction", {
          workflow_type_name: "Delivery",
          workflow_id: t.data.delivery.workflow_id,
          business_id: t.data.business.id, // restaurant business ID
          created_by: t.created_by,
          data: obj,
        })
        .then((res) => {
          this.log("ecommerce_create_delivery", this.retryCount);
          this.successToast(this.$t("delivery.requesting-delivery-driver"));
          this.t.delivery = res.data;
          this.done(); // goes back to update commerce dispatch state
        })
        .catch((err) => {
          var shop = t.data.business.name;
          var msg = `🚨 ecommerce_create_delivery FAILED x${this.retryCount} @ ${shop} ${this.ref}`;
          if (this.retryCount >= 1) this.sendSuperuserNotification(msg);
          this.$store.dispatch("logError", {
            type: "ecommerce_create_delivery",
            error: err.toString(),
            retry_count: this.retryCount,
          });
          console.error("createDeliveryTransaction", err);
          if (err.message === "Network Error" && this.retryCount < 3) {
            setTimeout(() => this.createDeliveryTransaction(), 1500);
            this.retryCount += 1;
            this.warningToast("Retrying 🤞🏽");
          } else {
            this.apiError(err);
            this.isSubmitted = false; // in case of error without retry
            // this.close();
            this.reinit();
            this.errorToast("Please try again 🤕");
            this.updateOrdersCommerceAgent();
          }
          var errMsg = `<i class='fa fa-spinner fa-spin'></i>&nbsp;Please wait a moment`;
          this.infoToast(errMsg, "top", 2500);
        });
    },
    // probably deprecate this because I automatically retry from server till infinite...
    retryDelivery() {
      sounds("mystery_long");
      var t = this.t.delivery;
      var loader = this.loadingDots();
      this.$store
        .dispatch("patchTransaction", {
          transactionID: t.id,
          data: { state: "initiated", data: { retry: true } },
        })
        .then(() => {
          this.thankYou("We are retrying the delivery request 🤞🏽");
          this.updateOrdersCommerceAgent(true);
          setTimeout(() => this.close(), 1000);
        })
        .catch((err) => console.error(err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  /* max-width: 600px; */
  /* margin: auto; */
  background-color: rgb(255, 255, 255);
  z-index: 21;
  backdrop-filter: blur(3px);
  overflow: hidden;
  text-align: left;
}

.total-sol {
  /* margin-left: 6px; */
  background-color: var(--crypto-secondary);
  /* color: var(--crypto-primary); */
  padding: 0 4px;
  border-radius: 3px;
  font-weight: 500;
  color: black;
}

.bg-pink {
  background-color: lavenderblush !important;
}

.bg-grey {
  background-color: #eee;
}

.is-flex {
  background-color: white;
}

.wrapper {
  padding: 12px;
  padding-bottom: 24px;
  text-align: left;
  height: 100vh;
  overflow: auto;
  max-width: 600px;
  margin: 0 auto;
  outline: 1px solid #ccc;
}

.dark {
  background-color: black;
}

.transaction {
  position: relative;
  /* width: 100%; */
  border-radius: 3px;
  border: 1px solid lightgrey;
  background-color: white;
}

.driver {
  margin-top: 8px;
}

.columns {
  margin: 0 0;
  padding: 4px 8px;
  /* width: 100%; */
}

.column.is-1 {
  padding: 0 0;
}

.ios-btn {
  padding: 0;
  font-size: 1.2em;
  height: 38px;
}

.ticket {
  background-color: azure;
  border: 2px dotted grey;
  border-radius: 3px;
  padding: 4px;
  font-family: "Bookman Old Style", "Times New Roman", Times, serif;
  flex-shrink: 1;
  text-align: center;
}

.tags {
  margin-bottom: 0;
}

.tags .tag {
  margin-bottom: 0;
}

.pad {
  margin-right: 8px;
  opacity: 0.7;
}

p {
  margin-bottom: 0px !important;
}

.pulse-red {
  animation: glow-red 0.8s infinite alternate;
}

@keyframes glow-red {
  to {
    text-shadow: 0 0 5px red, 0 0 10px red, 0 0 15px red,
      0 0 25px red;
  }
}

.pulse {
  animation: glow 0.8s infinite alternate;
}

@keyframes glow {
  to {
    text-shadow: 0 0 5px yellow, 0 0 10px yellow, 0 0 15px yellow,
      0 0 25px yellow;
  }
}

.wiggle:active {
  transform: rotate(340deg);
  -webkit-transform: rotate(340deg);
  -ms-transform: rotate(340deg);
}

.is-orange {
  background-color: orange;
}

.table {
  /* background-color: rgb(245, 245, 245); */
  /* border-radius: 2px; */
  margin-top: 10px;
  margin-bottom: 2px;
  /* border: 1px solid grey; */
  box-shadow: 0px 0px 1px grey;
}

.table .right {
  text-align: right;
}

.prep-time-selector {
  margin-bottom: 8px;
  padding: 8px;
  border-radius: 3px;
  /* background-color: yellow; */
  /* background-color: #ffdd57; */
  border: 1px solid orange;
}

.eta-btns {
  width: calc(((100vw - 24px) / 4) - 14px);
  max-width: calc(((600px - 24px) / 4) - 14px);
}

.contain-img {
  object-fit: contain !important;
}


/* /////////////////////////// */
img {
  border-radius: 3px;
}

.driver-img {
  object-fit: cover;
  height: 70px;
  width: 70px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
  margin-bottom: -7px;
}

.item-img {
  /* height: 140px !important;
  width: auto; */
  object-fit: cover;
  height: 140px;
  width: 140px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
  margin-right: 4px;
}

.tag {
  padding: 0 6px;
}

.staff-notes {
  background-color: #fed8b1;
  padding: 0 2px;
  border-radius: 2px;
  box-shadow: 0 0 1px grey;
}

.description {
  background-color: lightyellow;
  padding: 0 2px;
  border-radius: 2px;
  box-shadow: 0 0 1px grey;
}

.mitten-wrapper {
  margin-left: 6px;
  /* border: 1px solid rgba(128, 128, 128, 0.6); */
  opacity: 0.7;
  box-shadow: 0 0 1px black;
}

/* .mitten-wrapper {
  margin-left: 8px;
  padding: 0 8px;
  border-radius: 50%;
  border: 1px solid rgba(128, 128, 128, 0.6);
  opacity: 0.7;
  background-color: white;
} */
.no-driver {
  text-align: left;
  padding: 6px 10px;
  font-style: italic;
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}

.payment {
  background-color: snow;
  padding: 0 4px;
  border-radius: 4px;
  margin-left: 4px;
  font-weight: 500;
}

.more-info {
  position: relative;
  /* background-color: rgba(255, 255, 0, 0.6); */
  padding: 2px;
  border-radius: 3px;
  margin-left: -6px;
  width: calc(100% + 12px);
  /* border: 1px solid #ddd; */
}

.options {
  background-color: rgba(255, 255, 0, 0.6);
  padding: 2px;
  border-radius: 3px;
  margin-left: -6px;
  width: calc(100% + 12px);
  border: 1px solid #ddd;
}

.td-options {
  padding-top: 0;
}

.options td {
  border-bottom: 1pt solid black;
  padding: 2px 6px;
}

.option-menu {
  font-weight: 500;
  opacity: 0.5;
  font-size: 0.9em;
}

.no-bottom-border td {
  border-bottom: none;
  /* padding-bottom: 0; */
}

tbody.items {
  width: 100%;
  border-bottom: 1px solid rgb(215, 215, 215);
  background-color: rgb(245, 245, 245);
}

.item-complete {
  background-color: rgb(205, 255, 204) !important;
}

.edit-order-wrapper {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  /* height: 100%; */
  padding: 10px;
  padding-bottom: 20px;
  /* background-color: #9ff8ead8; */
  /* background-color: rgba(221, 221, 221, 0.9); */
  /* background-color: rgba(238, 238, 238, 1); */
  background-color: #1f1b24;
  /* backdrop-filter: blur(4px); */
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  box-shadow: 0px -2px 2px rgba(100, 100, 100, 0.2);
  color: white;
}

.test-order {
  font-size: 0.7em;
  font-weight: 550;
  opacity: 0.7;
  color: red;
}

.special-item-positive {
  color: green;
}

.special-item-negative {
  color: red;
}

.order-notes {
  /* margin: -1px; */
  /* margin-top: 4px; */
  margin-top: 6px;
  margin-bottom: -4px;
  background-color: rgba(255, 255, 0, 0.6);
  padding: 3px;
  border-radius: 3px;
  box-shadow: 0px 0px 1px grey;
}

.delivery-notes {
  /* margin: -1px; */
  margin-top: 6px;
  margin-bottom: -4px;
  /* background-color: rgba(255, 255, 0, 0.6); */
  padding: 3px;
  border-radius: 3px;
  box-shadow: 0px 0px 1px grey;
}

.cancel-edit {
  float: left;
  color: white;
}

.plate-number {
  position: sticky;
  /* margin-top: -6px; */
  margin-top: -13px;
  width: 70px;
  border: 1px dotted black;
  background-color: rgba(221, 221, 221, 0.7);
  border-radius: 3px;
  /* line-height: 1.2em; */
  line-height: 0.9em;
  font-size: 0.8em;
  font-weight: 500;
  text-overflow: hidden;
  white-space: nowrap;
  overflow: hidden;
}

.name {
  width: calc(100vw - 170px);
  max-width: calc(600px - 170px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-bottom: 8px;
}

.has-text-ccc {
  color: #ccc;
}

.map-btn {
  width: 100%;
  font-weight: 550;
  font-size: 0.9em;
  line-height: 1.8em;
  text-shadow: 0 0 3px white, 0 0 1px white, 0 0 4px white;
  /* margin-bottom: 20px; */
  background-image: url("~@/assets/map_button_background.png");
  background-size: cover;
  background-position: top;
  /* margin-top: 5px; */
  border: 1.5px solid var(--info);
  padding: 0 8px;
  border-radius: 4px;
  text-align: left;
}

.map-btn:hover {
  color: var(--info) !important;
}

.order-cnt {
  float: right;
  font-size: 0.8em;
  font-weight: 500;
  /* opacity: 0.5; */
  height: 0;
  margin-top: -16px;
  line-height: 1em;
  background-color: white;
}

.order-cnt span {
  color: var(--success);
  padding: 0 4px;
  border-radius: 30px;
  border: 1px solid lightgreen;
}

.order-cnt .grey {
  border: 1px solid #ccc;
  border-radius: 3px;
  color: #999;
}

.big-table-row {
  font-size: 1.3em;
  line-height: 1em;
  /* vertical-align: bottom; */
}

.phone-btn {
  position: absolute;
  right: 0;
  top: 0;
}

thead th {
  background-color: white;
  border-bottom: 1px solid #ddd;
}

.tuk-express {
  font-size: 12pt;
  font-weight: 550;
  color: #fac002;
  position: absolute;
  margin-top: 2px;
  margin-left: 2px;
  text-shadow: 0 0 1px white;
}

.driver-wrapper {
  border: 1px solid #ddd;
  border-radius: 4px;
}

.category-name {
  font-weight: 500;
  color: #999;
  display: block;
}

.notification {
  margin-bottom: 10px;
}

.single-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* display: inline-block; */
  max-width: 100%;
}

.shop-name {
  font-weight: 500;
  color: grey;
}

.info {
  padding: 3px 0;
  color: black;
  float: right;
}

.order-id {
  float: right;
  background-color: #eee;
  border: 1px solid #ddd;
  font-size: 0.7em;
  text-align: center;
  border-radius: 4px;
  padding: 0 3px;
  font-family: monaco;
}

.fulfilment {
  font-weight: 650;
  padding: 10px;
  border: 1px solid black;
  /* text-shadow: 0 0 1px grey; */
}

/* .fa-trash-alt {
  text-shadow: 0 0 5px #aaa;
} */
.items-shadow {
  box-shadow: inset 0 0 0 3px var(--danger);
}

.items-shadow td {
  padding-top: 16px;
  padding-bottom: 16px;
}

.trash-btn {
  background-color: white;
  border-radius: 100px;
  padding: 2px 6px;
  margin-right: -6px;
  box-shadow: 0 0 3px grey;
}

.nowrap {
  white-space: nowrap;
}

.sku {
  position: absolute;
  left: -4px;
  top: -4px;
  background-color: black;
  color: white;
  border-radius: 3px;
  line-height: 1em;
  font-size: 0.85em;
  padding: 2px;
  box-shadow: 0 0 2px white;
}

.tuk-express-wrapper {
  padding: 8px 8px 0 8px;
  z-index: 2px;
  border-bottom: 1px solid #ddd;
}

.tuk-express-wrapper>p {
  background-color: lightcyan;
  margin: 4px -8px;
  padding: 4px 8px;
}

.customer-wrapper {
  flex: 1;
  padding: 6px 8px;
  padding-right: 4px;
  position: relative;
}

.confirmed-ago {
  float: right;
  text-align: right;
  /* display: inline-block; */
  font-size: 0.75em;
  font-weight: 450;
  height: 0;
  line-height: 1em;
}

.by-weight {
  outline: 3px solid grey;
  background-color: white;
  padding: 2px 4px;
  margin: -4px;
  /* margin-bottom: 6px !important; */
}

.out-of-stock {
  background-color: var(--danger);
  margin-left: -6px;
  padding: 3px 6px;
  font-weight: 550;
  color: white;
  border-radius: 3px;
}

@media print {

  /* div:not(.to-print) {
    display: none;
  } */
  /* div.no-print {
    display: none;
  }
  div.to-print {
    display: block;
  } */
  .to-print,
  .to-print * {
    visibility: visible;
    /* display: block; */
  }

  .main,
  .main * {
    visibility: hidden;
    /* display: none; */
  }
}

@media print {
  body * {
    visibility: hidden;
    /* background-color: black; */
  }

  #to-print,
  #to-print * {
    visibility: visible;
    background-color: white;
  }

  #to-print {
    position: absolute;
    left: 0;
    top: 0;
    background-color: white;
    margin: 0;
    padding: 0;
  }
}
</style>

<style>
.dv_handler {
  margin-top: 1px;
  margin-left: 1px;
}
</style>